// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"bez_a bhl_pw bhl_a bhl_w bhl_j bhl_q","LoadError__icon":"bez_b bhl_uf bhl_fg bhl_rq","LoadError__message":"bez_c bhl_fg bhl_sl"};